import React, { useState, useEffect } from "react";
import styles from "./Errormessage.module.css";
import Image from "next/image"; // Use Next.js Image component for optimized image loading
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Link from "next/link";

const ErrorSection: React.FC = () => {
  const [homeUrl, setHomeUrl] = useState("/");

  useEffect(() => {
    // Get country from SelectedCountryByUser cookie
    if (typeof document !== "undefined") {
      try {
        const cookieString = document.cookie || "";
        const match = cookieString.match(/SelectedCountryByUser=([^;]+)/);
        const cookieCountry = match ? decodeURIComponent(match[1]) : null;

        if (cookieCountry && cookieCountry !== "south-africa") {
          setHomeUrl(`/${cookieCountry}`);
        } else {
          setHomeUrl("/");
        }
      } catch (error) {
        console.warn("Error reading cookie:", error);
        setHomeUrl("/");
      }
    }
  }, []);

  return (
    <div className={`${styles.errorSection} container`}>
      <Breadcrumbs leftAlignDropdown />
      <div className={styles.errorContainer}>
        <div className={styles.errorImage}>
          <Image
            src="/assets/404-image.png" // Replace with the actual path to your 404 image
            alt="404 Error"
            title="404 Error"
            width={500} // Adjust width
            height={300} // Adjust height
          />
        </div>
        <p className={styles.errorMessage}>
          Sorry We Can&apos;t Find That Page!
        </p>
        <p className={styles.errorDescription}>
          The page you are looking for was moved, removed, renamed or never
          existed.
        </p>
        <Link
          href={homeUrl}
          title="Back to home"
          passHref
          className={styles.homeButton}
        >
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default ErrorSection;
